import styled from 'styled-components';

// ------------------------------------------------------
// Styles for virtualized list
// ------------------------------------------------------

export const HistoryList = styled.div.attrs({
  className: 'reportingHistoryList',
})`
  height: 600px; // Override this by selecting for the class
  overflow-y: scroll;
`;

export const RelativePosDiv = styled.div`
  width: '100%';
  position: relative;
  height: ${(props: { height: number }) => `${props.height}px`};
`;

export const AbsolutePosDiv = styled.div`
  position: 'absolute';
  top: 0;
  left: 0;
  width: '100%';
  transform: ${(props: { start: number }) => `translateY(${props.start}px)`};

  display: flex;
  flex-direction: column;
  gap: 20px;
`;